export default "__VITE_ASSET__BRYv9QVa__"